export const ensureHttps = (url) => {
  if (!url) return '';
  if (typeof url !== 'string') return url;
  
  // Если ссылка уже https, возвращаем как есть
  if (url.startsWith('https://')) {
    return url;
  }
  
  // Если ссылка http, заменяем на https
  if (url.startsWith('http://')) {
    return url.replace('http://', 'https://');
  }
  
  return url;
};
